import { render, staticRenderFns } from "./DistributeIpTable.vue?vue&type=template&id=3837ef50&"
import script from "./DistributeIpTable.vue?vue&type=script&lang=js&"
export * from "./DistributeIpTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports